module.exports = __webpack_public_path__ + "img/icon-follow-poster.e2574a5e.png";